import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { AuthenticationService } from "../authentication.service";
import { IInstance } from "../../home/model/i-instance";

@Injectable({
  providedIn: "root",
})
export class InstancesService {
  private currentInstanceSubject: BehaviorSubject<IInstance>;

  public currentInstance: Observable<IInstance>;

  private viewerTypeSubject: BehaviorSubject<any>;

  public viewerType: Observable<any>;

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {
    this.currentInstanceSubject = new BehaviorSubject<IInstance>(null);
    this.currentInstance = this.currentInstanceSubject.asObservable();
    this.viewerTypeSubject = new BehaviorSubject<any>(null);
    this.viewerType = this.viewerTypeSubject.asObservable();
  }

  loadMaps() {
    return this.http
      .get<any>(
        `${
          environment.viewerUrl
        }/external/viewerAPI/maps/user?${this.authenticationService.getQueryAuth()}`
      )
      .pipe(map((response) => response));
  }

  setLastInstance(instanceId: string) {
    const formData = new FormData();
    formData.append("instanceId", instanceId);
    return this.http.post<any>(
      `${
        environment.viewerUrl
      }/external/user/setLastInstance?${this.authenticationService.getQueryAuth()}`,
      formData
    );
  }

  lastInstance() {
    return this.http.get<any>(
      `${
        environment.viewerUrl
      }/external/user/lastInstance?${this.authenticationService.getQueryAuth()}`
    );
  }

  getCurrentInstance() {
    return this.currentInstanceSubject.getValue();
  }

  setCurrentInstance(instance: IInstance) {
    this.currentInstanceSubject.next(instance);
    this.setViewerType(instance.instanceType); // when change instance we put instance viewer selected
  }

  setViewerType(type: number) {
    this.viewerTypeSubject.next(type);
  }

  getViewerType(): number {
    return this.viewerTypeSubject.getValue();
  }

  logout() {
    this.currentInstanceSubject.next(null);
  }
}
